import React, { Component } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Page from './Page';
import connect from '../store/connect';
import { Container } from '../styles/Container';
import { SITE_ROOT_URL } from '../constants/endpoints';
import { InnerContainer } from './OrderConfirmationPage';
import { fetchArticlePageView } from '../actions/actionCreators';
import NewsletterSignUpForm from '../components/NewsletterSignUpForm';
import { size } from '../styles/helpers/variables';
import { FAILURE, INITIAL, LOADING, SUCCESS } from '../constants/status';
import { Conditional } from '../components/Conditional';
import { dynamicFontSize } from '../styles/helpers/mixins';
import { Heading } from '../styles/Heading';
import { LoadingSpinner } from '../components/LoadingSpinner';

class NewsletterPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: INITIAL
    };

    this.setStatus = this.setStatus.bind(this);
  }

  componentWillMount() {
    this.props.fetchArticlePageView({ urlPath: this.props.location.pathname });
  }

  setStatus(newStatus) {
    this.setState({
      status: newStatus
    });
  }

  render() {
    const { currentPage } = this.props;
    const { status } = this.state;

    const imageUrl = currentPage.getIn(['fields', 'image', 'url']);

    return (
      <Page title="Nyhetsbrev" bgImg={imageUrl && `${SITE_ROOT_URL}${imageUrl}`} noBreadcrumbs>
        <Container bgColor="transparent" style={{ paddingTop: '0', paddingBottom: '0', minHeight: '60vh' }}>
          <InnerContainer>
            <WhiteContainer>
              <Conditional show={status === INITIAL}>
                <NewsletterPageHeading big margin="0 0 1rem">
                  {currentPage.getIn(['fields', 'title'])}
                </NewsletterPageHeading>

                <NewsletterPageBodyText
                  dangerouslySetInnerHTML={{ __html: currentPage.getIn(['fields', 'bodyText']) }}
                />

                <FormContainer>
                  <NewsletterSignUpForm
                    placeholder={currentPage.getIn(['fields', 'inputEmailPlaceholder'])}
                    privacyPolicy={currentPage.getIn(['fields', 'acceptTermsText'])}
                    buttonText={currentPage.getIn(['fields', 'subscribeButtonText'])}
                    onUpdateStatus={this.setStatus}
                  />
                </FormContainer>
              </Conditional>

              <Conditional show={status === LOADING}>
                <LoadingSpinner margin="66px auto !important" />
              </Conditional>

              <Conditional show={status === SUCCESS}>
                <NewsletterPageHeading big margin="0 0 1rem">
                  {currentPage.getIn(['fields', 'subscriptionSuccessTitle'])}
                </NewsletterPageHeading>

                <NewsletterPageBodyText
                  dangerouslySetInnerHTML={{ __html: currentPage.getIn(['fields', 'subscriptionSuccessText']) }}
                />
              </Conditional>

              <Conditional show={status === FAILURE}>
                <NewsletterPageHeading big margin="0 0 1rem">
                  Ops!
                </NewsletterPageHeading>

                <NewsletterPageBodyText>
                  <p>Något gick fel, vänligen försök igen.</p>
                </NewsletterPageBodyText>
              </Conditional>
            </WhiteContainer>
          </InnerContainer>
        </Container>
      </Page>
    );
  }
}

NewsletterPage.defaultProps = {
  currentPage: Map()
};

NewsletterPage.propTypes = {
  fetchArticlePageView: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  currentPage: PropTypes.instanceOf(Map)
};

export default connect(
  NewsletterPage,
  { fetchArticlePageView },
  (store, props) => ({
    currentPage: store.page.data.get(props.location.pathname)
  })
);

const WhiteContainer = styled.div`
  width: 100%;
  margin: 0 auto 20px;
  max-width: 950px;
  background-color: white !important;
  display: flex;
  min-height: 450px;

  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 27px 17px;

  @media screen and (min-width: ${size.large}px) {
    margin: 0 auto 28px;
    padding: 57px 100px;
    min-height: 550px;
  }
`;

const FormContainer = styled.div`
  max-width: 560px;
  width: 100%;
  margin: 0 0 30px;

  @media screen and (min-width: ${size.large}px) {
    margin: 0 0 50px;
  }

  @media screen and (min-width: ${size.xLarge}px) {
    margin: 0 0 70px;
  }
`;

const NewsletterPageHeading = styled(Heading)`
  margin: 0 0 0.5rem;
  @media screen and (min-width: ${size.large}px) {
    margin: 0 0 2rem;
  }
`;

const NewsletterPageBodyText = styled.div`
  margin-bottom: 17px;

  p {
    ${dynamicFontSize(16, 20)};
    font-weight: 300;
    line-height: 1.55;
    text-align: center;
    margin: 0 0 1em;
  }

  a {
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }

  span {
    font-weight: 600;
  }

  ${props =>
    props.color &&
    css`
      color: ${props.color};
    `};

  @media screen and (min-width: ${size.large}px) {
    margin-bottom: 33px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/NewsletterPage.js